// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1PgsT","range":"MonthRangeSwitch_range__2fctb","disabled":"MonthRangeSwitch_disabled__13J9g"};